import React from 'react';
import styled, { css } from 'styled-components';
import { media } from '~constants/media';
import { Table, Props } from '~components/Table';
import { Block, Td, Th } from '~components/Table/styledComponents';

const tableCellCSS = css`
  padding-left: 7px;
  font-size: 13px;
  line-height: 15px;
  color: #706f6f;

  ${media.lg`
    font-size: 16px;
    line-height: 18px;
    padding-left: 10px;
  `}
`;

const StyledTable = styled(Table)`
  ${Block} {
    padding: 0 9px;

    ${media.md`
        padding: 0 15px;
      `}
  }

  ${Td} {
    padding-top: 13px;
    padding-bottom: 13px;
    padding-right: 12px;

    &:not(:first-child) {
      &:before {
        position: absolute;
        content: '';
        height: 64%;
        top: 18%;
        left: 0;
        width: 1px;
        background: #e7e7e7;
      }
    }

    ${tableCellCSS};
  }

  ${Th} {
    padding-top: 17px;
    padding-bottom: 17px;

    ${tableCellCSS};
  }
` as typeof Table;

const GreyTable = <T extends Record<string, any>>(props: Props<T>) => {
  return <StyledTable openerIcon='chevron' {...props} />;
};

export default GreyTable;
